<template>
  <div v-if="fileContents && fileContents.DataRecords">
    <h3>
      {{ i18n.t('/change-order/bulk/uploaded-file-title') }}
    </h3>
    <div class="table-scroll-container">
      <table>
        <thead>
          <tr>
            <th>
              {{ i18n.t('/change-order/bulk/file/komnumber') }}
            </th>
            <th>
              {{ i18n.t('/change-order/bulk/file/kom-year') }}
            </th>
            <th>
              {{ i18n.t('/change-order/bulk/file/reference-date') }}
            </th>
            <th v-if="showNetCatalogPrice">
              {{ i18n.t('/change-order/bulk/file/net-price') }}
            </th>
            <th v-if="showBpm">
              {{ i18n.t('/change-order/bulk/file/bpm') }}
            </th>
            <th v-if="showBtw">
              {{ i18n.t('/change-order/bulk/file/btw') }}
            </th>
            <th v-if="showFiscalValue">
              {{ i18n.t('/change-order/bulk/file/fiscal-value') }}
            </th>
            <th>
              {{ i18n.t('/change-order/bulk/file/status') }}
            </th>
            <th v-if="showErrorMessages" class="error-col">
              {{ i18n.t('/change-order/bulk/file/errors') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="record in fileContents.DataRecords" :key="record.Id">
            <td>{{ record.KomNumber }}</td>
            <td>{{ record.KomYear }}</td>
            <td>{{ record.ReferenceDate }}</td>
            <td v-if="showNetCatalogPrice">{{ i18n.n(record.NetCatalogPrice, 'currency') }}</td>
            <td v-if="showBpm">{{ i18n.n(record.Bpm, 'currency') }}</td>
            <td v-if="showBtw">{{ i18n.n(record.Btw, 'currency') }}</td>
            <td v-if="showFiscalValue">{{ i18n.n(record.FiscalValue, 'currency') }}</td>
            <td>{{ record.Status }}</td>
            <td v-if="showErrorMessages" class="error-col">{{ record.ErrorMessage }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fileContents: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    showNetCatalogPrice() {
      return this.fileContents.DataRecords.some((record) => record.NetCatalogPrice != null)
    },
    showBpm() {
      return this.fileContents.DataRecords.some((record) => record.Bpm != null)
    },
    showBtw() {
      return this.fileContents.DataRecords.some((record) => record.Btw != null)
    },
    showFiscalValue() {
      return this.fileContents.DataRecords.some((record) => record.FiscalValue != null)
    },
    showErrorMessages() {
      return this.fileContents.DataRecords.some((record) => record.ErrorMessage != null)
    },
  },
}
</script>

<style lang="scss" scoped>
.table-scroll-container {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: calc(100vh - 530px);
  width: 100%;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

th,
td {
  padding: 8px;
  border: 1px solid #ddd;
  text-align: left;
  white-space: nowrap;
}

th {
  background-color: #f2f2f2;
  position: sticky;
  top: 0;
  z-index: 1;
}

.error-col {
  white-space: normal;
  word-break: break-word;
  min-width: 200px;
}
</style>
